import type {
  FurnitureDef,
  FurnitureId,
  IglooFloorId,
  IglooPlacement,
  IglooStyle,
  IglooSurfaceDef,
  IglooWallId,
} from "@clubap/shared";
import { economyGet, economyPost } from "./api.js";

/**
 * Llamadas del módulo del iglú, escritas sobre los helpers de `api.ts`.
 *
 * Ninguna dice de quién es el cuarto: el servidor siempre opera sobre el de quien
 * manda el token. Lo que el cliente pide es "compra esto", "pon esto acá".
 */

export interface IglooSnapshot {
  furniture: FurnitureDef[];
  /** Cuántas piezas de cada mueble se poseen, puestas incluidas. */
  owned: Record<string, number>;
  placements: IglooPlacement[];
  balance: number;
  maxPlaced: number;
  floors: IglooSurfaceDef<IglooFloorId>[];
  walls: IglooSurfaceDef<IglooWallId>[];
  style: IglooStyle;
}

export function fetchIgloo(): Promise<IglooSnapshot> {
  return economyGet<IglooSnapshot>("igloo", "/");
}

export interface BuyResult {
  furniture: FurnitureDef;
  balance: number;
  owned: Record<string, number>;
}

export function buyFurniture(furnitureId: FurnitureId): Promise<BuyResult> {
  return economyPost<BuyResult>("igloo", "/buy", { furnitureId });
}

interface PlacementsResult {
  placements: IglooPlacement[];
}

export function placeFurniture(
  furnitureId: FurnitureId,
  x: number,
  y: number,
): Promise<IglooPlacement[]> {
  return economyPost<PlacementsResult>("igloo", "/place", { furnitureId, x, y }).then(
    (result) => result.placements,
  );
}

export function moveFurniture(
  placementId: string,
  x: number,
  y: number,
): Promise<IglooPlacement[]> {
  return economyPost<PlacementsResult>("igloo", "/move", { placementId, x, y }).then(
    (result) => result.placements,
  );
}

export function removeFurniture(placementId: string): Promise<IglooPlacement[]> {
  return economyPost<PlacementsResult>("igloo", "/remove", { placementId }).then(
    (result) => result.placements,
  );
}

/** Cambia el piso y la pared. No cuesta monedas: es aspecto. */
export function setIglooStyle(floor: IglooFloorId, wall: IglooWallId): Promise<IglooStyle> {
  return economyPost<{ style: IglooStyle }>("igloo", "/style", { floor, wall }).then(
    (result) => result.style,
  );
}
